
















import { Component, Mixins } from 'vue-property-decorator';
import { Office, MapSettings, MapMarker } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { Map } from 'client-website-ts-library/components';
import { View } from 'client-website-ts-library/plugins';
import Form from '@/components/Forms/Form.vue';

@Component({
  components: {
    Map,
    Form,
  },
})
export default class ContactUs extends Mixins(View) {
  private office: Office | null = null;

  private mapSettings: MapSettings | null = null;

  mounted() {
    const markers = [];
    markers.push(
      new MapMarker({
        Title: 'City Office',
        Coordinate: {
          Lat: -16.9255626,
          Lon: 145.7724344,
        },
      }),
      new MapMarker({
        Title: 'Redlynch Office',
        Coordinate: {
          Lat: -16.8924297,
          Lon: 145.6938839,
        },
      }),
      new MapMarker({
        Title: 'South Office',
        Coordinate: {
          Lat: -17.0917093,
          Lon: 145.7840229,
        },
      }),
    );

    this.mapSettings = new MapSettings({
      Markers: markers,
      Interactive: true,
    });
  }
}
